import { __decorate } from "tslib";
import { Component, Vue, Ref, Watch, Prop } from 'vue-property-decorator';
import authItem from '@blade/common/components/auth/auth-item.vue';
import tableHeader from '@blade-sxp/task-management/components/table-header.vue';
import tableModel from '@blade-sxp/device-management/components/model.vue';
import viewModel from '@blade-sxp/device-management/components/view-model.vue';
import colors from '@/styles/color.scss';
import { devicesList, getRtsp, deleteDevice, addLike, cancelLike, likeAll, likePage, } from '@blade-sxp/device-management/api/device-management/index';
let default_1 = class default_1 extends Vue {
    multipleTable;
    title = '';
    deviceId = 0;
    loading = false;
    form;
    groupId;
    colors = colors;
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    type = '';
    dialogVisible = false;
    viewDialogVisible = false;
    rtsp = '';
    taskList = [];
    selsectMap = new Map();
    changeSearchVal() {
        this.pagination.page = 1;
        this.getTaskList();
    }
    selectChange(valList, val) {
        let isAdd = valList.length && valList.indexOf(val) !== -1;
        if (isAdd) {
            this.selsectMap.set(val.deviceId, val);
        }
        else {
            this.selsectMap.delete(val.deviceId);
        }
        this.$emit('getDeviceList', this.selsectMap);
    }
    // 批量删除
    selectAll(val) {
        if (val.length) {
            this.taskList.forEach((it) => {
                this.selsectMap.set(it.deviceId, it);
            });
        }
        else {
            this.taskList.forEach((it) => {
                this.selsectMap.delete(it.deviceId);
            });
        }
        this.$emit('getDeviceList', this.selsectMap);
    }
    like(device) {
        if (device.like) {
            this.cancelLike(device.deviceId);
        }
        else {
            this.addlike(device.deviceId);
        }
    }
    addlike(deviceId) {
        addLike(deviceId).then((res) => {
            this.$message({ type: 'success', message: `${this.$t('addedFavourites')}` });
            this.getAllLike(true);
        });
    }
    cancelLike(deviceId) {
        if (this.groupId === 'favorites') {
            cancelLike(deviceId).then((res) => {
                this.getTaskLikeList(true);
                // this.getAllLike(true);
            });
        }
        else {
            cancelLike(deviceId).then((res) => {
                this.getAllLike(true);
            });
        }
    }
    getAllLike(type) {
        likeAll().then((res) => {
            this.taskList.map((value) => {
                this.$set(value, 'like', false);
                for (let item of res) {
                    if (item.deviceId === value?.deviceId) {
                        this.$set(value, 'like', true);
                    }
                }
            });
            if (type) {
                this.$emit('msgSuccess', this.groupId);
            }
        });
    }
    goView(id) {
        this.deviceId = id;
        this.dialogVisible = true;
        this.type = 'view';
    }
    addDeviceSuccess() {
        this.$emit('msgSuccess', this.groupId);
        this.getTaskList();
    }
    changeGroupId() {
        this.pagination.page = 1;
        this.getTaskList();
    }
    handleSizeChange(size) {
        this.pagination.size = size;
        this.getTaskList(true);
    }
    handleCurrentChange(page) {
        this.pagination.page = page;
        this.getTaskList(true);
    }
    CheckedKeys(e) {
        this.getTaskList();
    }
    changeType() {
        this.type = 'edit';
    }
    selectTable() {
        this.selsectMap.forEach((val, key) => {
            this.taskList.forEach((it, idx) => {
                if (it.deviceId === key) {
                    this.$nextTick(() => {
                        this.$refs.multipleTable.toggleRowSelection(it, true);
                    });
                }
            });
        });
    }
    // 查询收藏任务
    getTaskLikeList(type) {
        let param = {
            page: this.pagination.page,
            size: this.pagination.size,
            deviceStatus: this.form?.deviceStatus || undefined,
            keywords: this.form?.keywords || undefined,
            protocolType: this.form?.protocolType || undefined,
            deviceType: this.form?.deviceType || undefined,
            groupId: this.groupId || undefined,
            analyticType: this.form?.analyticType || undefined,
            pageOrderList: [
                {
                    orderField: 'createTime',
                    orderType: 'DESC',
                },
            ],
            sort: 'DESC',
        };
        likePage(param)
            .then((res) => {
            if (res.list.length > 0) {
                this.taskList = res.list ? res.list : [];
                this.getAllLike();
            }
            else {
                this.taskList = [];
                if (res.totalPage > 1) {
                    this.pagination.page = res.totalPage;
                    this.getTaskLikeList();
                }
            }
            this.pagination.total = res.total;
            this.$emit('changeTopText');
        })
            .finally(() => {
            this.loading = false;
        });
        if (type) {
            this.$emit('msgSuccess', this.groupId);
        }
    }
    // 清空批量选项
    clearSelect() {
        this.selsectMap.clear();
        this.$emit('getDeviceList', this.selsectMap);
    }
    // 查询列表任务
    getAllTaskList() {
        let param = {
            page: this.pagination.page,
            size: this.pagination.size,
            deviceStatus: this.form?.deviceStatus || undefined,
            keywords: this.form?.keywords || undefined,
            protocolType: this.form?.protocolType || undefined,
            deviceType: this.form?.deviceType || undefined,
            groupId: this.groupId || undefined,
            analyticType: this.form?.analyticType || undefined,
            pageOrderList: [
                {
                    orderField: 'createTime',
                    orderType: 'DESC',
                },
            ],
            sort: 'DESC',
        };
        devicesList(param)
            .then((res) => {
            if (res.list.length > 0) {
                this.taskList = res.list ? res.list : [];
                this.getAllLike();
            }
            else {
                this.taskList = [];
                if (res.totalPage > 1) {
                    this.pagination.page = res.totalPage;
                    this.getAllTaskList();
                }
            }
            this.pagination.total = res.total;
            this.$emit('changeTopText');
        })
            .finally(() => {
            this.loading = false;
            this.selectTable();
            this.$emit('getDeviceList', this.selsectMap);
        });
    }
    getTaskList(val) {
        if (!val) {
            this.clearSelect();
        }
        this.loading = true;
        if (this.groupId === 'favorites') {
            this.getTaskLikeList();
        }
        else {
            this.getAllTaskList();
        }
    }
    /**
     *@Description: 删除任务
     */
    handleDelete(dataItem) {
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmDelete = `${this.$t('deleteMsg')}`;
        let title = `${this.$t('deleteTitle')}`;
        this.$elconfirm(deviceConfirmDelete, title, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.no')}`,
            confirmButtonText: confirm,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    deleteDevice(dataItem.deviceId).then((res) => {
                        this.$message({
                            message: this.$t('deletedSuccessfully'),
                            type: 'success',
                        });
                        this.getTaskList();
                        this.$emit('msgSuccess', this.groupId);
                    });
                }
            },
        });
    }
    /**
     *@Description: 编辑任务
     */
    handleEdit(id) {
        this.deviceId = id;
        this.type = 'edit';
        this.dialogVisible = true;
    }
    handleView(dataItem) {
        getRtsp(String(dataItem.deviceId)).then((res) => {
            this.rtsp = res.rtspPreviewAddress;
            this.title = dataItem.deviceName;
            this.viewDialogVisible = true;
        });
    }
    close() {
        this.rtsp = '';
    }
    mounted() { }
};
__decorate([
    Ref()
], default_1.prototype, "multipleTable", void 0);
__decorate([
    Prop()
], default_1.prototype, "form", void 0);
__decorate([
    Prop()
], default_1.prototype, "groupId", void 0);
__decorate([
    Watch('groupId', { immediate: false })
], default_1.prototype, "changeGroupId", null);
default_1 = __decorate([
    Component({
        name: 'tableBox',
        components: { authItem, tableHeader, tableModel, viewModel },
        i18n: {
            messages: {
                zh: {
                    name: '名称',
                    operation: '操作',
                    deviceType: '协议类型',
                    group: '组织',
                    url: '网址',
                    analyticType: '分析型',
                    onlineStatus: '状态',
                    view: '查看',
                    abnormal: '异常',
                    confirmDeleteAttr: '确认删除?',
                    online: '在线',
                    offline: '离线',
                    unknown: '未知',
                    cancel: '取消',
                    delete: '确认',
                    deletedSuccessfully: '删除成功',
                    total: '总共 {msg} 条',
                    deleteMsg: '设备已与该组关联。你确定要删除该组吗？',
                    deleteTitle: '提示',
                    deleteEnter: '该任务正在执行中，请暂停任务后再次尝试删除任务操作',
                    creationTime: '创建时间',
                    addedFavourites: '添加收藏夹成功',
                },
                'en-us': {
                    operation: 'Option',
                    total: 'Total {msg} Items',
                    name: 'Name',
                    deviceType: 'Protocol Type',
                    group: 'Group',
                    url: 'URL',
                    analyticType: 'Analytic Type',
                    onlineStatus: 'Online Status',
                    view: 'View',
                    online: 'Online',
                    offline: 'Offline',
                    unknown: 'Unknown',
                    confirmDeleteAttr: 'Are you sure to delete the device？',
                    cancel: 'Cancel',
                    delete: 'Delete',
                    deletedSuccessfully: 'Deleted successfully',
                    deleteMsg: 'Devices have been associated with the group. Are you sure you want to delete the group?',
                    deleteTitle: 'Toast',
                    deleteEnter: 'The task is in progress, please pause the task and try to delete the task again',
                    creationTime: 'Creation Time',
                    addedFavourites: 'Added to Favourites successfully',
                },
            },
        },
    })
], default_1);
export default default_1;
